// Dependencies
import React, { useState } from 'react';
import { NavLink } from 'react-router';

// App components
import ButtonFull from '../../global_components/buttons/ButtonFull';
import ButtonOutline from '../../global_components/buttons/ButtonOutline';
import ButtonFormSubmit from '../../global_components/buttons/ButtonFormSubmit';
import InputField from '../../global_components/form_components/InputField';

const LoginPage = () => {
  const [statusMessage, setStatusMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage("");

    const formData = {
      email: e.target.loginEmailAddress.value,
      password: e.target.loginPassword.value,
    };

    try {
      const response = await fetch("https://wad-backend.ws381566.remote.ac/login.php", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
        mode: "cors",
      });
      const result = await response.json();
      if (result.success === true) {
        window.location.href = '/dashboard/courses';
      }
      setStatusMessage(result.message);
    } catch (error) {
      setStatusMessage(error.message);
    }
  };

  return (
    <div className='w-full h-full flex flex-col items-center bg-[#161C33] px-5 sm:px-20 md:px-40 gap-5'>
      <div className='w-full flex flex-col gap-4 sm:flex-row items-center justify-between px-7 py-5' id='header'>
        <div className='text-center sm:text-left' id='logoContainer'>
          <h2 className="text-xl sm:text-2xl font-bold text-white">Don't Get Mugged!</h2>
          <h4 className="text-sm sm:text-md font-medium text-[#06BD60] uppercase mt-1">Training co.</h4>
        </div>
        <div className='flex flex-col gap-3 sm:flex-row items-center sm:items-center mt-5 sm:mt-0' id='buttonContainer'>
          <div className='mr-0 sm:mr-4 mb-3 sm:mb-0'>
            <ButtonFull buttonText='Login' navigationURL='/login' />
          </div>
          <div className=''>
            <ButtonOutline buttonText='Register' navigationURL='/register' />
          </div>
        </div>
      </div>
      <div className='flex flex-col items-start bg-white p-5 sm:p-10 lg:p-15 min-w-full sm:min-w-lg md:min-w-lg' id='formContainer'>
        <div id='formHeader' className='mb-5 sm:mb-7 flex flex-col items-start'>
          <h2 className='text-2xl sm:text-3xl uppercase font-black text-center sm:text-left'>Welcome back.</h2>
          <h4 className='text-base sm:text-lg mt-2 text-center sm:text-left'>Please login to continue</h4>
          {statusMessage && <h4 className="text-red-500 mt-2 text-center sm:text-left">{statusMessage}</h4>}
        </div>
        <form onSubmit={handleSubmit} className='w-full flex flex-col items-center sm:items-start gap-5'>
          <InputField for='loginEmailAddress' name='loginEmailAddress' labelText='Email address' inputType='email' inputRequired='required' />
          <InputField for='loginPassword' name='loginPassword' labelText='Password' inputType='password' inputRequired='required' />
          <div className='flex flex-col items-center sm:items-start gap-2'>
            <h4 className='text-sm sm:text-base text-[#06BD60] underline mt-2 cursor-pointer'>Forgot password?</h4>
            <h4 className='text-sm sm:text-base mt-2 text-center sm:text-left'>
              Don't have an account? 
              <NavLink to='/register' className='text-[#06BD60] underline cursor-pointer'> Register here</NavLink>
            </h4>
          </div>
          <ButtonFormSubmit buttonText='Login' overrideStyles='w-full sm:w-auto' />
        </form>
      </div>
    </div>
  );
}

export default LoginPage;